export function hearderRebellion(rebellionJson,app){
  rebellionJson = JSON.parse(rebellionJson)

  let strContent = ""
  let Str1 = ""
  let Str2 = ""
  //繰返しあり・なし[0:なし;1:月;2:週;3:日;4:年;]
  let repeatTypeCode = rebellionJson.repeatType
  //間隔値
  let intervalValueCode = rebellionJson.intervalValue

  //開始時間
  // let startTime = rebellionJson.startTime
  //終了時間
  // let endTime = rebellionJson.endTime
  //繰返し日・曜日 日[（-1：月末、1~31日）、曜日（0~6）]
  let repeatItems = rebellionJson.repeatItems
  let repeatItem = null
  if(repeatItems!=[] && repeatItems!=undefined && repeatItems!=null){
      repeatItem = repeatItems[0]
  }
  //終了日
  if("0" == repeatTypeCode){
    Str1 = app.$t('繰り返しなし')
  }else {
    Str1 = app.$t('繰り返し')

    if(intervalValueCode!=null || intervalValueCode!=undefined || intervalValueCode!=""){
        if("1" == repeatTypeCode){
          if (repeatItems.length == 2) {
            if (repeatItems[0] == -1) {
              Str2 =intervalValueCode + "ヶ月ごと 最終" + weekCodeOfValue(repeatItems[1]) + "曜日"
            } else {
              Str2 = intervalValueCode + "ヶ月ごと 毎月第" + repeatItems[0] + weekCodeOfValue(repeatItems[1]) + "曜日"
            }
          } else {
            Str2 = intervalValueCode+"ヶ月ごと 毎月"+repeatItem+"日"
          }
        }else if("2" == repeatTypeCode){
          let week = codeOfValue(repeatItems)
          Str2 = intervalValueCode+"週ごと 毎週"+week
        }else if("3" == repeatTypeCode){
          Str2 = intervalValueCode+"日ごと"
        }else if("4" == repeatTypeCode){
          if (repeatItems.length == 3) {
            if (repeatItems[1] == -1) {
              Str2 = "毎年" +repeatItems[0] + "月 最終" + weekCodeOfValue(repeatItems[2]) + "曜日"
            } else {
              Str2 = "毎年"+ repeatItems[0] +" 月第" + repeatItems[1] + weekCodeOfValue(repeatItems[2]) + "曜日"
            }
          } else {
            Str2 = " 毎年"+ repeatItems[0] +"月 "+repeatItems[1]+"日"
          }
        }
    }
  }


  strContent = Str1 + " " + Str2

  return strContent
}

function codeOfValue (weekList) {
  let loanDay = ""
  for(let week of weekList){
    if("1" == week){
      loanDay = loanDay + "月 "
    }else if("2" == week) {
      loanDay = loanDay + "火 "
    }else if("3" == week) {
      loanDay = loanDay + "水 "
    }else if("4" == week) {
      loanDay = loanDay + "木 "
    }else if("5" == week) {
      loanDay = loanDay + "金 "
    }else if("6" == week) {
      loanDay = loanDay + "土 "
    }else if("0" == week) {
      loanDay = loanDay + "日 "
    }
  }
  loanDay = loanDay.substring(0, loanDay.length - 1)
  return loanDay
}

function weekCodeOfValue (value){
  let loanDay = ""
  if("1" == value){
    loanDay = "月"
  }else if("2" == value) {
    loanDay = "火"
  }else if("3" == value) {
    loanDay = "水"
  }else if("4" == value) {
    loanDay = "木"
  }else if("5" == value) {
    loanDay = "金"
  }else if("6" == value) {
    loanDay = "土"
  }else if("0" == value) {
    loanDay = "日"
  }
  return loanDay
}
